import UserService from "../keycloak/UserService";

const PrivateRoute = ({ children }) => {
  if (UserService.getToken()) {
    return children;
  } else {
    UserService.doLogin({
      redirectUri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URL,
    });
    return null;
  }
};

export default PrivateRoute;
